import { Component, OnInit } from '@angular/core';
import { AnimationHelper } from 'src/app/helpers/animation.helper';
import { IModalDialog } from 'src/app/interfaces/ux/modal-dialog.interface';
import { DialogService } from 'src/app/services/ux/dialog.service';

@Component({
  selector: 'app-modals-layer',
  templateUrl: './modals-layer.component.html',
  styleUrls: ['./modals-layer.component.scss']
})
export class ModalsLayerComponent implements OnInit {
  constructor(
    private dialogSv: DialogService
  ) {
  }

  ngOnInit(): void {
  }

  get hasModals() {
    return this.dialogSv.hasModals;
  }

  get lastModal(): IModalDialog {
    return this.dialogSv.currentModal;
  }

  get modalZ() {
    return 110 + this.dialogSv.visibleModals.length;
  }

  get allowClose() {
    return this.lastModal.allowClose;
  }

  get hasButtons() {
    return (this.lastModal.buttons && this.lastModal.buttons.length > 0) ||
      this.lastModal.okButton ||
      this.lastModal.cancelButton;
  }

  manageClick(ev: MouseEvent) {
    ev.preventDefault();

    if (this.hasModals) {
      ev.stopPropagation();
    }
  }

  manageContextMenu(ev: MouseEvent) {
    if (this.hasModals) {
      ev.preventDefault();
      ev.stopPropagation();
    }
  }

  async buttonClick(index) {
    this.lastModal.cb(index);
    await this.dialogSv.closeModal();
  }

  async closeClick() {
    this.lastModal.cb(-1);
    await this.dialogSv.closeModal();
  }
}
